import { IConfig } from '@cian/config/shared';

export const isSubAgentsChatsEnabled = (config: IConfig): boolean => {
  return Boolean(config.get<boolean>('frontend-chats.SubAgentsChats.Enabled'));
};
